export enum TipoCadastro {
    Medidas = "Medidas",
    TiposDePneus = "TiposDePneus",
    Marcas = "Marcas",
    FormaDePagamento = "FormaDePagamento",
    TiposDeProdutos = "TiposDeProdutos",
    CanaisDeComunicacao = "CanaisDeComunicacao"
}

// Mapeamento de descrição
export const TipoCadastroDescricao: Record<TipoCadastro, string> = {
    [TipoCadastro.Medidas]: "Medidas",
    [TipoCadastro.TiposDePneus]: "Tipo de pneu",
    [TipoCadastro.Marcas]: "Marcas",
    [TipoCadastro.FormaDePagamento]: "Forma de pagamento",
    [TipoCadastro.TiposDeProdutos]: "Tipos de produtos",
    [TipoCadastro.CanaisDeComunicacao]: "Canais de comunicação"
  };